import React, { useEffect, useState } from 'react'
import { getEmployeeResult } from '../../../../services/api-services';
import FinalAssesmentsubmitionModal from '../../../../admin/pages/comman/finalAssesmentsubmitionModal';
import SmallBarChart from '../SmallBarChart';
import MaturityScale from '../MaturityScale';
import { useLocation, useNavigate } from 'react-router-dom';
import { USERROUTES } from '../../../routes/url-constant';
import MaturityScalepreviewall from '../MaturityScalepreviewall';
import SmallBarChartPreviewall from '../smallBarChartPreviewall';



const PreviewAllAns = ({ CampaignData, parsedEmployeeData, handleaddAnswer, setShowPreview, finalAssesmentModal, setFinalAssesmentModal, submitBtnDisable, backBtnDisable }) => {
    const location = useLocation();
    let Data = location?.state?.Data;
    let PageType = location?.state?.pageType;
    const navigate = useNavigate();

    const [expanded, setExpanded] = useState(false);
    const [questionAnswer, setquestionAnswer] = useState([]);


    const levelMapping = {
        Initiating: 1,
        Emerging: 2,
        Performing: 3,
        Advancing: 4,
        Leading: 5,
    };

    const getAnsQus = async (id) => {
        try {
            const response = await getEmployeeResult(PageType == "Score" ? Data?.campaignId : CampaignData?.campaignId, PageType == "Score" ? Data?.employeeId : parsedEmployeeData?.id, PageType == "Score" ? Data?.modelId : CampaignData?.modelId);
            if (response?.data?.responseCode === 200 || response?.data?.responseCode == "SUCCESS") {
                const modifiedQuestionAnswer = response?.data?.data?.questionResponseList?.map(question => {
                    const optionValues = question.optionResponseList?.map(option => option.value);
                    return {
                        ...question,
                        optionResponseList: optionValues, // replace the original optionResponseList with the transformed array
                    };
                });
                setquestionAnswer(modifiedQuestionAnswer)
                //   setRemark(response?.data?.data?.remark)
            }
        } catch (err) {
            // toastEmitter("error", API_RESPONSE.MESSAGE_503);
        }
    }

    useEffect(() => {
        getAnsQus(parsedEmployeeData?.id);
    }, [])

    return (
        <>
            <div>
                <div className='preview-sec'>
                    {PageType == "Score" ? <button disabled={backBtnDisable} className='resultpublishbtn px-3 mb-0' onClick={() => navigate(USERROUTES?.USERPROFILEINTRODUCTION)}> Back to Introduction</button> : <>
                        <button disabled={backBtnDisable} className='resultpublishbtn px-3 mb-0' onClick={() => setShowPreview(false)}> Back to Answers</button>
                        <button disabled={submitBtnDisable} className='quiznextbtn px-3' onClick={() => handleaddAnswer("Submit", setFinalAssesmentModal)}>Definitely Submit</button>
                    </>}
                </div>
                {questionAnswer.length ?
                    questionAnswer?.map((data, i) => {
                        const importantLevel = levelMapping[data?.important] || 0;
                        return (
                            <div
                                key={i}
                                className={`row m-0 ${i === 0 ? "mt-5" : "mt-1"}`}
                            >
                                <div className="col-md-12">
                                    <div className={`result_top_section ${i === 0 ? "mt-5" : "mt-1"}`}>
                                        <p>{i + 1}) {data?.question}</p>
                                        <div className="row">
                                            <div className="col-md-3 text-center">
                                                <SmallBarChartPreviewall value={importantLevel} maturityScales={false} />
                                            </div>

                                            <div className="col-md-9">
                                                {/* Example: Show Current and Future in MaturityScale */}
                                                <MaturityScalepreviewall
                                                    currentLevel={data?.current}
                                                    targetLevel={data?.future}
                                                    optionLabel={true}
                                                />
                                            </div>
                                        </div>
                                        {data?.comment && <div className='row'>
                                            <div className='col-12'>
                                                <h5 className='small_bar_chart mt-5'>Comment:</h5>
                                                <div className="comment-wrapper">
                                                    <p className={`comment-data ${expanded ? "expanded" : "collapsed"}`}>
                                                        {data?.comment}
                                                    </p>

                                                    {(data?.comment?.split("\n").length > 3 || data?.comment?.length > 150) && (
                                                        <button
                                                            onClick={() => setExpanded(!expanded)}
                                                            className="show-toggle-btn"
                                                        >
                                                            {expanded ? "Show less" : "Show more"}
                                                        </button>
                                                    )}
                                                </div>
                                            </div>
                                        </div>}
                                    </div>
                                </div>
                            </div>
                        );
                    }) : <div className='result_top_section'><p className='mt-5'>You haven’t answered any of my questions, so nothing was found</p></div>
                }
                <FinalAssesmentsubmitionModal finalAssesmentModal={finalAssesmentModal} setFinalAssesmentModal={setFinalAssesmentModal} />
            </div>
        </>
    )
}

export default PreviewAllAns;
